import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WifiOff } from 'lucide-angular';
import { AdsIconDirective } from '../ads';
import { MrezaService } from './mreza.service';

/**
 * „Niste na mreži”: preko cijelog zaslona dok uređaj nema mreže.
 *
 * Aplikacija ispod ostaje živa (unos se ne gubi); kad se veza vrati, stranica nestaje sama.
 * Bez gumba za ponovno učitavanje: bez service workera bi ponovno učitavanje bez mreže
 * završilo na pregledniku bez stranice i izgubilo unos.
 * S instaliranim service workerom i otvaranje aplikacije bez mreže dolazi ovdje
 * (ljuska aplikacije je u cacheu, podaci s API-ja nisu).
 */
@Component({
  selector: 'app-pwa-offline',
  imports: [AdsIconDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (!mreza.naMrezi()) {
      <div class="ds-applikator pwa-offline">
        <div class="pwa-offline__kartica" role="alert" aria-labelledby="pwa-offline-naslov">
          <span class="pwa-offline__ikona"><svg [appAdsIcon]="ikona"></svg></span>
          <h1 id="pwa-offline-naslov" class="pwa-offline__naslov">Niste na mreži</h1>
          <p class="pwa-offline__tekst">Provjerite internetsku vezu. Kad se veza vrati, nastavljate gdje ste stali.</p>
        </div>
      </div>
    }
  `,
  styles: `
.pwa-offline{position:fixed;inset:0;z-index:1000;display:grid;place-items:center;
  padding:max(var(--gutter),env(safe-area-inset-top,0px)) var(--gutter) max(var(--gutter),env(safe-area-inset-bottom,0px));
  background:var(--paper);overflow:auto}
.pwa-offline__kartica{display:grid;justify-items:center;gap:12px;max-width:420px;padding:var(--dialog-pad);text-align:center;
  background:var(--card);border-radius:var(--r-lg);box-shadow:var(--shadow-card)}
.pwa-offline__ikona{display:grid;place-items:center;width:var(--tile);height:var(--tile);border-radius:var(--r-md);
  background:var(--tint);color:var(--blue);font-size:22px}
.pwa-offline__naslov{font-size:20px;line-height:1.25;letter-spacing:-.02em;font-weight:700;color:var(--ink);text-wrap:balance}
.pwa-offline__tekst{font-size:15px;line-height:1.55;color:var(--body);max-width:60ch;text-wrap:pretty}
`,
})
export class PwaOfflineComponent {
  protected readonly mreza = inject(MrezaService);
  protected readonly ikona = WifiOff;
}
